<template>
  <div class="container mx-auto px-4 py-6 sm:py-8">
    <h1 class="text-2xl sm:text-3xl font-bold mb-2 sm:mb-4 text-gray-800 dark:text-gray-200">Search Results</h1>
    <p v-if="$route.query.q" class="mb-4 text-gray-600 dark:text-gray-400 text-sm sm:text-base">
      Showing results for: <span class="font-medium">"{{ $route.query.q }}"</span>
    </p>
    
    <div v-if="loading" class="text-center py-8">
      <div class="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-500 mx-auto"></div>
      <p class="mt-4 text-gray-600 dark:text-gray-400">Loading results...</p>
    </div>
    
    <div v-else-if="results.length === 0" class="text-center py-12">
      <p class="text-gray-600 dark:text-gray-400 text-lg">No results found.</p>
      <p class="mt-2 text-gray-500 dark:text-gray-500 text-sm">Try different keywords or browse our latest posts.</p>
      <router-link to="/" class="mt-4 inline-block bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded transition-colors duration-200">
        Back to Home
      </router-link>
    </div>
    
    <div v-else class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
      <BlogCard v-for="post in results" :key="post.id" :post="post" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import BlogCard from '@/components/BlogCard.vue';
import { searchPosts } from '@/services/api';

export default {
  name: 'Search',
  components: {
    BlogCard,
  },
  setup() {
    const route = useRoute();
    const results = ref([]);
    const loading = ref(true);

    const performSearch = async (query) => {
      loading.value = true;
      try {
        results.value = await searchPosts(query);
      } catch (error) {
        console.error('Error searching posts:', error);
        results.value = [];
      }
      loading.value = false;
    };

    onMounted(() => {
      if (route.query.q) {
        performSearch(route.query.q);
      }
    });

    watch(() => route.query.q, (newQuery) => {
      if (newQuery) {
        performSearch(newQuery);
      } else {
        results.value = [];
      }
    });

    return {
      results,
      loading,
    };
  },
};
</script>
